<template lang="pug">
   MDashboardWidget( title="Audits selected by reasons" )

    div(class="form-group row")

      div(class="col-sm-10")
        label Date range
        input( type="date" placeholder="End date" class="form-control" v-model="startDate" )
        input( type="date" placeholder="Start date" class="form-control" v-model="endDate" )
      
      div(class="col-sm-10")
        select( class="form-control" v-model="selectedCause" v-bind:disabled="loading" )
          option( selected v-bind:value="undefined" ) None
          option( v-for="cause in causes" v-bind:value="cause.id" ) {{ cause.reason }}

      div(class="col-sm-12 mt-3")
        button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="! selectedCause  || loading" v-on:click="csvAuditsWithReason('standard')" )
          i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
          | Moonpull Standard Report
        button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="! selectedCause  || loading" v-on:click="csvAuditsWithReason('client-standard')" )
          i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
          | Client Standard Report
        button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="! selectedCause  || loading" v-on:click="csvAuditsWithReason('debug')" )
          i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
          | Debug Report
        button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="! selectedCause  || loading" v-on:click="csvAuditsWithReason('full')" )
          i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
          | Multi Line Report
        
      p( class="text-danger m-0" v-if="errorMessage" ) {{ errorMessage }}
</template>
<script>
import Vue from "vue";
import gql from "graphql-tag";
import * as dateFormat from "dateformat";
export default Vue.extend({
  data() {
    return {
      startDate: dateFormat(
        new Date(Date.now() - 69 * 24 * 60 * 60 * 1000),
        "yyyy-mm-dd"
      ),
      endDate: dateFormat(new Date(), "yyyy-mm-dd"),
      loading: false,
      errorMessage: "",
      reasonId: "",
      selectedCause: null
    };
  },

  apollo: {
    causes: {
      query: gql`
        query {
          causeMany {
            id
            reason
          }
        }
      `,
      update: (data) => data.causeMany,
    },
  },
  methods: {
    async csvAuditsWithReason(type) {
      this.loading = true;
      const {
        data: { csvAuditsWithReason },
      } = await this.$apollo.query({
        query: gql`
          query csvAuditsWithReason(
            $reasonId: ID!
            $type: String!
          ) {
            csvAuditsWithReason(
              reasonId: $reasonId
              type: $type
            )
          }
        `,
        variables: {
          reasonId: this.selectedCause,
          type
        },
      });
      // If no audits were found display error message
      if (!csvAuditsWithReason) {
        this.errorMessage = "No audits were found for the given search";
      }
      // Otherwise, generate CSV download
      else {
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display:none");
        const blob = new Blob([csvAuditsWithReason], { type: "octet/stream" });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = `batches_${this.startDate}_${this.endDate}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
      }

      this.loading = false;
    },
  },
});
</script>